import React from "react";
import NotFound from "../../NotFound";
import styles from "./NoDataRow.module.scss";

export const NoDataRow = ({ colLength }: { colLength: number }) => {
  return (
    <tr className={styles.row}>
      <td colSpan={colLength}>
        <NotFound />
      </td>
    </tr>
  );
};
